import { useState } from 'react';
import { X, LogIn } from 'lucide-react';
import { signInWithGoogle } from '../services/authService';
import '../styles/sign-in-modal.css';

function SignInModal({ isOpen, onClose, onSignInSuccess }) {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    if (!isOpen) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    const handleClose = () => {
        setError(null);
        onClose();
    };

    const handleSignIn = async () => {
        setError(null);
        setIsLoading(true);
        
        try {
            await signInWithGoogle();
            setIsLoading(false);
            if (onSignInSuccess) {
                onSignInSuccess();
            } else {
                onClose();
            }
        } catch (err) {
            setIsLoading(false);
            // Display French error message
            if (err.message.includes('popup was closed')) {
                setError('La fenêtre de connexion a été fermée. Veuillez réessayer.');
            } else if (err.message.includes('Network error')) {
                setError('Erreur réseau. Veuillez vérifier votre connexion.');
            } else if (err.message.includes('blocked')) {
                setError('La fenêtre de connexion a été bloquée. Veuillez autoriser les popups.');
            } else {
                setError('Échec de la connexion. Veuillez réessayer.');
            }
        }
    };

    return (
        <div className="sign-in-modal-overlay" onClick={handleOverlayClick}>
            <div className="sign-in-modal-content">
                <button className="sign-in-modal-close" onClick={handleClose} aria-label="Fermer">
                    <X size={20} />
                </button>
                
                <div className="sign-in-modal-icon">
                    <LogIn size={32} />
                </div>
                
                <h2 className="sign-in-modal-title">Connexion requise</h2>
                
                <p className="sign-in-modal-message">
                    Veuillez vous connecter pour télécharger ce modèle 3D.
                </p>

                {error && (
                    <p className="sign-in-modal-error">{error}</p>
                )}
                
                <div className="sign-in-modal-actions">
                    <button 
                        className="sign-in-modal-btn-primary" 
                        onClick={handleSignIn}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Connexion...' : 'Se connecter'}
                    </button>
                    <button className="sign-in-modal-btn-secondary" onClick={handleClose}>
                        Annuler
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SignInModal;
